import React, { useEffect, useState } from 'react';
const PURCHASE_LINK = 'https://f13dpf-q0.myshopify.com/cart/47511845830810:1?channel=buy_button';
// Start the clock at 00:12:59 (matches a fresh, almost-expired feel) and loop it.
const INITIAL_TOTAL = 12 * 60 + 59;
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-17">
      <div className="bg-[#2a0808] border border-red-600/70 rounded-xl w-[68px] md:w-[84px] py-3 md:py-4 shadow-[0_0_18px_rgba(220,38,38,0.35)]" style={{
      fontFamily: 'Montserrat, sans-serif'
    }} data-id="element-18">
        <span className="block text-3xl md:text-5xl font-black text-red-400 tabular-nums leading-none text-center" data-id="element-19">
          {value}
        </span>
      </div>
      <span className="mt-2 text-[10px] md:text-xs font-bold tracking-widest text-red-300/80 uppercase" data-id="element-20">
        {label}
      </span>
    </div>;
}
export function UrgencyScarcity() {
  const [totalSeconds, setTotalSeconds] = useState(INITIAL_TOTAL);
  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds(prev => prev <= 1 ? INITIAL_TOTAL : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  // Scarcity: last 3 spots out of 50 → 47 already taken (94% filled).
  const spotsLeft = 3;
  const totalSpots = 50;
  const taken = totalSpots - spotsLeft;
  const filledPct = Math.round(taken / totalSpots * 100);
  return <section className="py-4" id="urgencia" data-id="element-21">
      <div className="relative overflow-hidden rounded-3xl bg-black border border-red-800/60 px-5 py-8 md:px-10 md:py-10 shadow-[0_20px_60px_rgba(0,0,0,0.5)]" data-id="element-22">
        {/* subtle premium glow */}
        <div className="pointer-events-none absolute inset-0 opacity-60" style={{
        background: 'radial-gradient(120% 90% at 50% 0%, rgba(220,38,38,0.18) 0%, rgba(0,0,0,0) 60%)'
      }} aria-hidden="true" data-id="element-23" />

        <div className="relative" data-id="element-24">
          {/* Alert pill */}
          <div className="flex justify-center mb-6" data-id="element-25">
            <span className="inline-flex items-center gap-2 bg-red-600 text-white text-xs md:text-sm font-black px-5 py-2.5 rounded-full uppercase tracking-wide shadow-[0_0_20px_rgba(220,38,38,0.55)] animate-pulse" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-26">
              🔥 ¡Atención! Oferta a punto de finalizar
            </span>
          </div>

          {/* Headline */}
          <h2 className="text-center text-3xl md:text-5xl font-black text-white leading-tight uppercase mb-2" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-27">
            Aprovechá el <span className="text-red-500" data-id="element-28">50% OFF</span>
            <br data-id="element-29" />
            <span className="text-2xl md:text-4xl" data-id="element-30">antes de que termine</span>
          </h2>

          <p className="text-center text-sm md:text-base text-gray-300 max-w-lg mx-auto mb-8 leading-relaxed" data-id="element-31">
            Esta promoción para{' '}
            <strong className="text-white" data-id="element-32">Emprendedoras Nu Skin</strong> es
            exclusiva y limitada. Cuando el reloj llegue a cero o se agoten los
            cupos, vuelve al precio regular.
          </p>

          {/* COUNTDOWN BOX */}
          <div className="bg-[#1a0505] border border-red-700/60 rounded-2xl p-5 md:p-7 mb-5" data-id="element-33">
            <p className="text-center text-red-400 font-black text-sm md:text-base uppercase tracking-widest mb-5" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-34">
              ⏰ La oferta expira en
            </p>
            <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-35">
              <TimeBox value={hh} label="Horas" data-id="element-36" />
              <span className="text-3xl md:text-4xl font-black text-red-500 -mt-6" data-id="element-37">
                :
              </span>
              <TimeBox value={mm} label="Minutos" data-id="element-38" />
              <span className="text-3xl md:text-4xl font-black text-red-500 -mt-6" data-id="element-39">
                :
              </span>
              <TimeBox value={ss} label="Segundos" data-id="element-40" />
            </div>
          </div>

          {/* SCARCITY BOX */}
          <div className="bg-[#1a0505] border border-red-700/60 rounded-2xl p-5 md:p-7 mb-6" data-id="element-41">
            <p className="text-center text-red-400 font-black text-sm md:text-base uppercase tracking-widest mb-3" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-42">
              👥 Cupos disponibles
            </p>
            <p className="text-center mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-43">
              <span className="text-5xl md:text-6xl font-black text-white align-middle" data-id="element-44">
                {spotsLeft}
              </span>
              <span className="text-xl md:text-2xl font-bold text-gray-400 align-middle" data-id="element-45">
                {' '}
                / {totalSpots}
              </span>
            </p>
            {/* Animated progress bar */}
            <div className="w-full h-3 rounded-full bg-[#3a0a0a] overflow-hidden" data-id="element-46">
              <div className="h-full rounded-full bg-gradient-to-r from-red-700 to-red-500 relative overflow-hidden transition-all duration-700" style={{
              width: `${filledPct}%`
            }} data-id="element-47">
                <span className="absolute inset-0 opacity-70" style={{
                background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0) 100%)',
                animation: 'shimmer 1.8s infinite'
              }} aria-hidden="true" data-id="element-48" />
              </div>
            </div>
            <p className="text-center text-xs md:text-sm text-red-300/80 mt-3 font-medium" data-id="element-49">
              Se están agotando rápido — últimos{' '}
              <strong className="text-red-400" data-id="element-50">3 cupos</strong> ·{taken} ya
              tomados
            </p>
          </div>

          {/* Footer warning */}
          <p className="text-center text-sm text-gray-400 leading-relaxed" data-id="element-51">
            🔒 Una vez que el contador llegue a 00:00,{' '}
            <strong className="text-red-400" data-id="element-52">esta oferta desaparece</strong> y
            el precio sube a{' '}
            <span className="line-through text-gray-500" data-id="element-53">ARS 79.990</span>
          </p>
        </div>
      </div>
    </section>;
}